<template>
  <div class="success">
    <house-pc-header class="success_pc_header"><span>賬號設置</span></house-pc-header>
    <div class="success_pc_block">
      <house-wap-header class="success_wap_header"></house-wap-header>
      <div class="success_pc_bar">
        <progress-bar step="3"></progress-bar>
      </div>
      <div class="success_wap_logo">
        <svg class="icon icon_success success_pc_icon" aria-hidden="true">
          <use xlink:href="#icon-chenggong"></use>
        </svg>
        <p class="info_success success_pc_info">{{ lang.passwordResetSuccessLang }}</p>
      </div>

      <div class="red_btn" @click.enter="login">
        {{ lang.loginLang }}<span v-show="count != 0">({{ count }}S)</span>
      </div>
    </div>
  </div>
</template>

<script>
import lang from '../../../common/language/new_login'
import houseWapHeader from '../../components/houseLogin/houseWapHeader'
import progressBar from '../../components/houseLogin/progressBar'
import housePcHeader from '../../components/houseLogin/housePcHeader'
export default {
  data() {
    return {
      num: 5,
      count: null,
      timer: null,
      lang: lang
    }
  },
  mounted() {
    this.countDown()
  },
  methods: {
    backLogin() {
      //判断是否返回原生登入页面
      if (navigator.userAgent.indexOf('house730') > -1) {
        let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1 //android终端
        const isFlutter = navigator.userAgent.indexOf('flutter') > -1
        if (isFlutter) {
          window.house730.postMessage(JSON.stringify({ type: 'jumpLogin', data: {} }))
        } else if (isAndroid) {
          window.house730.jumpLogin()
        } else {
          window.webkit.messageHandlers.jumpLogin.postMessage(JSON.stringify({}))
        }
      } else {
        this.$router.push('/login')
      }
    },
    //点击登入
    login() {
      console.log('登入')
      this.backLogin()
      clearInterval(this.timer)
    },
    //倒计时登入
    countDown() {
      this.count = this.num
      this.timer = setInterval(() => {
        this.count = --this.count
        if (this.count == 0) {
          this.backLogin()
          clearInterval(this.timer)
        }
      }, 1000)
    }
  },
  components: {
    houseWapHeader,
    progressBar,
    housePcHeader
  }
}
</script>
<style lang="scss" scoped>
@import url('../../assets/base.css');

.success {
  padding: 0 15px;
  height: 100%;

  .icon_success {
    font-size: 80px;
  }
  .info_success {
    text-align: center;
  }
  .red_btn {
    background-color: #e8112c;
  }
  .success_pc_header {
    display: none;
  }
  .success_pc_bar {
    display: none;
  }
  .success_wap_logo {
    display: flex;
    align-items: center;
    padding: 50px 0;
  }
}

@media screen and (min-width: 601px) {
  .success {
    overflow: auto;
    height: 100%;
    background-color: #f4f4f4;
    padding: 0;

    .success_wap_header {
      display: none;
    }
    .success_pc_header {
      display: block;
    }
    .success_pc_bar {
      display: block;
    }
    .success_pc_block {
      background-color: #fff;
      margin: 0 auto;
      margin-top: 40px;
      width: 1200px;
      padding-bottom: 130px;
      font-size: 16px;
      display: flex;
      align-items: center;
      flex-direction: column;
      .success_wap_logo {
        display: block;
        padding: 0;
      }
      .success_pc_icon {
        font-size: 140px;
      }
      .success_pc_info {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin-bottom: 90px;
      }
    }
    .red_btn {
      width: 200px;
    }
  }
}
</style>
